import React, { useState } from "react";
import { Card, InputNumber, Input, Button, message } from "antd";
import { PlayCircleOutlined } from "@ant-design/icons";

const DeepTrackPage = () => {
  const [params, setParams] = useState({
    numParticles: 100,
    noiseLevel: 0.05,
    imageSize: 64,
    epochs: 20,
    batchSize: 16,
  });

  const handleChange = (field, value) => {
    setParams({ ...params, [field]: value });
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch("/api/start_deeptrack_training/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(params),
      });
      const result = await response.json();
      if (result.status === "ok") {
        message.success("训练任务已启动！");
      } else {
        message.error("训练启动失败！");
      }
    } catch (err) {
      message.error("网络错误：" + err.message);
    }
  };

  return (
    <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* 简介 */}
      <Card title="📌 DeepTrack 2.1 简介" bordered className="rounded-2xl shadow-md">
        <p>
          DeepTrack 是基于 TensorFlow 的显微图像模拟和追踪工具，适用于颗粒追踪、显微模拟和深度学习训练。
          本平台已整合其训练模块，支持自定义粒子数量、噪声、图像尺寸等参数，云端启动训练并返回结果。
        </p>
      </Card>

      {/* 参数输入 */}
      <Card title="🧪 参数设置" bordered className="rounded-2xl shadow-md space-y-4">
        <div>粒子数量：<InputNumber min={1} max={500} value={params.numParticles} onChange={(val) => handleChange("numParticles", val)} /></div>
        <div>噪声强度：<InputNumber min={0} max={1} step={0.01} value={params.noiseLevel} onChange={(val) => handleChange("noiseLevel", val)} /></div>
        <div>图像尺寸：<InputNumber min={32} max={128} value={params.imageSize} onChange={(val) => handleChange("imageSize", val)} /></div>
        <div>训练轮次（epochs）：<InputNumber min={1} max={100} value={params.epochs} onChange={(val) => handleChange("epochs", val)} /></div>
        <div>Batch Size：<InputNumber min={1} max={128} value={params.batchSize} onChange={(val) => handleChange("batchSize", val)} /></div>
        <Button type="primary" icon={<PlayCircleOutlined />} onClick={handleSubmit}>开始训练</Button>
      </Card>

      {/* 训练结果 */}
      <Card title="📊 训练结果与日志" bordered className="rounded-2xl shadow-md">
        <p>训练完成后将生成以下内容：</p>
        <ul className="list-disc list-inside">
          <li>track.txt：追踪结果坐标</li>
          <li>train_log.txt：训练日志</li>
          <li>preview.mp4：可视化视频预览</li>
        </ul>
        <p>请前往 <a href="/history" className="text-blue-500 underline">/history</a> 页面查看结果</p>
      </Card>
    </div>
  );
};

export default DeepTrackPage;
